import React, {useEffect} from "react";
import SubTitle from "../../components/SubTitle";
import {useForm, FormProvider, SubmitHandler} from "react-hook-form";
import {useCreateMutation, useUpdateMutation} from "../../hooks/useQueryHooks";
import {ResponseItem, ResponseList} from "../../models/clientModels/interfaces/Response";
import {useNavigate, useParams} from "react-router-dom";

import * as Params from "../../models/clientModels/interfaces/apiParams";

import * as postAip from "../../api/boardApi/postAip";

import {useQuery, useQueryClient} from "react-query";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {snackBarState, snackBarToggleState} from "../../Recoil/Atom/snackBarState";
import ConfirmButtonGroup from "../../components/ConfirmButtonGroup";
import {FormSection} from "../../styledComponents/StyledCreateForm";
import MWProgress from "../../components/MWProgress";
import {tokenSelector} from "../../Recoil/Atom/authState";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import {KPBoard, initializeBoard} from "../../models/serverModels/board/KPBoard";
import PostForm from "./PostForm";
import {KPPost, initializePost} from "../../models/serverModels/board/KPPost";

const CreatePost = () => {
  const {id, name} = useParams();
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const tokenState = useRecoilValue(tokenSelector);

  const setSnackBarState = useSetRecoilState(snackBarState);
  const setSnackBarToggle = useSetRecoilState(snackBarToggleState);

  const {mutate: createMutate, isLoading} = useCreateMutation<
    ResponseItem<KPPost>,
    Params.Create<KPPost>
  >({
    api: postAip.create,
    options: {
      onSuccess: () => {
        setSnackBarToggle(true);
        setSnackBarState("create");
        navigate(`/Post/${id}`);
        queryClient.invalidateQueries("getBoardWithPostList");
      },
      onError: () => {
        setSnackBarToggle(true);
        setSnackBarState("failed");
      },
    },
  });

  const methods = useForm<KPPost>({
    defaultValues: initializePost(parseInt(id!)),
  });

  const onSubmit: SubmitHandler<KPPost> = (data) => {
    createMutate({
      token: tokenState,
      item: {...initializePost(parseInt(id!)), ...data},
    });
  };

  return (
    <FormProvider {...methods}>
      <SubTitle subTitle={`${name} 작성`} />
      {isLoading && <MWProgress />}
      <FormSection>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <PostForm />
          <ConfirmButtonGroup link={`/Post/${id}`} cancelText="취소" confirmText="작성" />
        </form>
      </FormSection>
    </FormProvider>
  );
};

export default CreatePost;
